/**
 * A custom initiator got executed.
 */ const INITIATOR_EXECUTION = "RCB/Initiator/Execution";
export { INITIATOR_EXECUTION };
